var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-scale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart/product-photo",
    transform: "translate(-5.000000, -59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo/scale-tool"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-scale",
    transform: "translate(5.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    fillOpacity: 0.8,
    fill: "#363E4A",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32948755,9.67876819 C8.63501252,10.3083737 7.68336797,10.6587669 6.64440063,10.4653615 C5.33247358,10.2211548 4.22583998,9.07709757 4.03063675,7.7359152 C3.767893,5.93068207 5.22725454,4.04397292 7.17513756,4.00054785 C7.20301925,4.00010528 7.23089045,4 7.25878262,4 C8.73898469,4.01416231 10.1278509,5.15279271 10.4175124,6.62303847 C10.6083149,7.59151973 10.2828086,8.60692451 9.64071253,9.35815398 C9.67061645,9.38896565 9.70043655,9.42233793 9.73039286,9.45628978 C9.82979667,9.40542524 9.94557743,9.37827008 10.0768131,9.3798507 C10.2570748,9.38634181 10.4299601,9.45904007 10.5591421,9.58328783 C11.0465844,10.0640616 11.3543604,10.2927038 11.8299312,10.7853639 C12.1982922,11.1767269 11.9341758,11.9571453 11.3649536,11.9982205 C11.1646895,12.0126674 10.9619632,11.9385887 10.814162,11.7964167 C10.3267302,11.3156429 10.0190065,11.0869691 9.54339382,10.5943617 C9.33968254,10.3779107 9.28927338,10.0337136 9.42539174,9.7684213 C9.3922292,9.73832618 9.35966389,9.70845234 9.32948755,9.67876819 Z M7.17299127,4.91722549 C6.13227685,4.92720479 5.15982212,5.72420946 4.9506433,6.75401904 C4.74078629,7.78721943 5.33521019,8.92717509 6.29904344,9.33789975 C7.35905233,9.78960463 8.72778118,9.28265589 9.24015272,8.22785504 C9.76880927,7.13953889 9.26760241,5.65649558 8.1526009,5.1320034 C7.84761945,4.98853846 7.51264511,4.91616114 7.17299127,4.91722549 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale);
export default __webpack_public_path__ + "static/media/icon-scale.83a00cad76a42b9fffa53074e4d964ee.svg";
export { ForwardRef as ReactComponent };